"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var tooltip_1 = require("../tooltip");
var icon_1 = require("../icon");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var config_context_1 = require("../_util/config-context");
exports.Button = (0, forward_ref_with_statics_1.forwardRefWithStatics)(function (props, ref) {
    var disabled = props.disabled, icon = props.icon, size = props.size, block = props.block, ghost = props.ghost, tempLoading = props.loading, tempType = props.type, className = props.className, style = props.style, onClick = props.onClick, children = props.children, tooltip = props.tooltip, htmlType = props.htmlType, buttonProps = (0, tslib_1.__rest)(props, ["disabled", "icon", "size", "block", "ghost", "loading", "type", "className", "style", "onClick", "children", "tooltip", "htmlType"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _a = (0, tslib_1.__read)([tempLoading, tempType], 2), loading = _a[0], type = _a[1];
    var iconProps;
    // 指定了图标的话，
    if (!type) {
        type = 'weak';
    }
    if (icon) {
        type = 'icon';
        typeof icon === 'string' ? iconProps = { type: icon } : iconProps = icon;
    }
    // 只有下面三种类型的按钮支持 loading
    if (['primary', 'weak', 'pay', 'error', 'dashed', 'link'].indexOf(type) === -1
        && typeof loading !== 'undefined') {
        loading = false;
    }
    // 计算类名
    var btnClassName = classPrefix + "-btn";
    var classList = [classPrefix + "-btn"];
    // 类型类名
    if (type !== 'primary') {
        classList.push(btnClassName + "--" + type);
    }
    // 尺寸类名
    if (size) {
        classList.push(btnClassName + "--" + size);
    }
    // 幽灵样式类名
    if (ghost
        && ['primary', 'weak'].indexOf(type) !== -1) {
        classList.push(btnClassName + "--ghost");
    }
    // block样式类名
    if (block) {
        classList.push(btnClassName + "--block");
    }
    // 状态类名
    classList.push({
        'is-disabled': disabled,
        'is-loading': loading,
    });
    // 用户自定义类名
    if (className) {
        classList.push(className);
    }
    /* eslint-disable react/button-has-type */
    var button = (react_1.default.createElement("button", (0, tslib_1.__assign)({ ref: ref, className: classnames_1.default.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(classList), false)), onClick: (!disabled && !loading && onClick) || null, style: style || {}, type: htmlType, disabled: disabled }, buttonProps),
        loading && (react_1.default.createElement(icon_1.Icon, { type: !['weak', 'link', 'dashed'].includes(type) ? 'loading-white' : 'loading' })),
        icon ? react_1.default.createElement(icon_1.Icon, (0, tslib_1.__assign)({}, iconProps)) : children));
    /* eslint-enable react/button-has-type */
    if (tooltip) {
        button = react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, button);
    }
    return button;
}, {
    defaultLabelAlign: 'middle',
});
exports.Button.displayName = 'Button';
